import { omitBy, isNil, isEmpty } from "lodash";
import CryptoJS from 'crypto-js';
import { DriverCreationFormType } from "Types/new_driver_types";

const model = (data:DriverCreationFormType) => {

    const attachments = [
        {
            attachmentType:'ID',
            fileName:data?.nric_passport?.fileName,
            fileType:'DOCUMENT',
            base64String:data?.nric_passport?.base64String,
        },
        {
            attachmentType:'LICENSE',
            fileName:data?.driving_license?.fileName,
            fileType:'DOCUMENT',
            base64String:data?.driving_license?.base64String,
        },
    ];

    if(data?.road_tax?.fileName){
        attachments.push({
            attachmentType:'ROAD_TAX',
            fileName:data?.road_tax?.fileName,
            fileType:'DOCUMENT',
            base64String:data?.road_tax?.base64String,
        });
    }

    if(data?.photo_of_vehicle?.fileName){
        attachments.push({
            attachmentType:'VEHICLE_PHOTO',
            fileName:data?.photo_of_vehicle?.fileName,
            fileType:'IMAGE',
            base64String:data?.photo_of_vehicle?.base64String,
        });
    }

    return omitBy({
        profile:{
            fullName:data.fullName,
            identification:{
                type:data.identityType,
                no:data.passportID,
            },
            primaryPhone: {
                countryCode: data.mobileNo.dialCode,
                number: data.mobileNo.number,
                fullNumber: `${data.mobileNo.dialCode}${data.mobileNo.number}`,
                type: "MOBILE"
            },
            primaryAddress:{
                street1:data.street1,
                street2:data?.street2,
                city:data.city,
                state:data.state,
                postcode:data.postcode,
                country:data.country,
            },
            primaryEmail:data.emailAddress,
            gender:data.gender,
        },
        parentOrgID:data.parentOrgID,
        data:omitBy({
            // companyName:data.diolkoCompany,
            riderType:data.riderType,
            vehicleCategory:data.vehicleCategory,
            vehicleType:data?.vehicleType,
            vehicleModel:data?.vehicleModel,
            vehiclePlateNumber:data?.plateNumber,
            payrollDetails:{
                bankType:data.bankType,
                accountNumber:data.accountNo,
                SOCSONo:data?.socsoNo,
                incomeTaxNo:data?.incomeTax,
                EPFNo:data?.epfNo,
                zakatNo:data?.zakatNo,
                HRDFNo:data?.hrdfNo,
            },
            emergencyContactName:data.emergencyContactName,
            emergencyContactNumber:!isNil(data.emergencyContactNo) ? {
                type:'MOBILE',
                countryCode:data.emergencyContactNo.dialCode,
                number:data.emergencyContactNo.number,
                fullNumber:`${data.emergencyContactNo.dialCode}${data.emergencyContactNo.number}`,
            } : null,
            emergencyRelationship:data.relationship,
        },isNil),
        attachments:attachments,
        // file:omitBy({
        //     fileName:data?.file?.fileName,
        //     fileType:data?.file?.fileType,
        //     base64String:data?.file?.base64String,
        // },isNil),
        password:data.password ? CryptoJS.SHA256(data.password).toString(CryptoJS.enc.Hex): undefined,
    },isEmpty)

}

export default model;